import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { fetch } from '../fetch';

const AddLabMemberBodySchema = z.object({
  labId: z.number(),
  email: z.string()
});
export type AddLabMemberBody = z.infer<typeof AddLabMemberBodySchema>;

export async function addLabMember(data: AddLabMemberBody, fetch: Fetch) {
  return fetch(
    `/lab-member`,
    { method: 'post', body: JSON.stringify(data) },
    schemas.AddLabMemberResponse
  );
}

export const useAddLabMemberMutation = () => {
  return useMutation({
    mutationKey: ['addLabMember'],
    mutationFn: async (data: AddLabMemberBody) => {
      const result = addLabMember(data, fetch);
      return result;
    }
  });
};
